<template>
  <Datatable :static="data" v-slot="{item}" :th="[$t('label.w16'),$t('label.w3'),$t('label.w17'),$t('label.w18'),$t('label.w19')]" :tip="$t('msg.m120')">
      <tr>
        <td class="td1">
          <p>{{$t('label.w10')}}{{item.Amount | cn}}</p>
          <p v-if="item.Progress==100">{{item.FakeOwnerName | name}} | {{item.Number}}</p>
          <p v-if="item.Progress!=100">{{item.FakeOwnerName}} | {{item.Number}}</p>
        </td>
        <td class="td2">{{item.Rate.toFixed(1)}}%{{item.AddRate==0?'':`+${item.AddRate}%`}}</td>
        <td
          class="td3"
        >{{item.LoanCycleValue<30?`${item.LoanCycleValue}${$t('label.w15')}`:`${item.LoanCycleValue/30}${$t('label.w14')}`}}</td>
        <td class="td4">
          <p>￥{{item.CurrentAmount | money}}/￥{{item.Amount | money}}</p>
          <p>
            <Progress
              :percent="item.Progress<0.5 && item.Progress!=0 ?0.5:item.Progress"
              hide-info
              :style="{width:'200px',}"
              stroke-color="#749EFC"
            />
          </p>
        </td>
        <td class="td5">
          <router-link :class="{finished:item.Progress>=100}" :to="{name:'borrowDetails',params:{id:item.Id}}">{{item.Progress<100?$t('btn.b38'):$t('btn.b66')}}</router-link>
        </td>
      </tr>
  </Datatable>
</template>
<script>
import Datatable from "../components/datatable";
export default {
  components: { Datatable },
  props: ["data"]
};
</script>
<style lang="less" scoped>
td {
  padding: 20px 0;
}
.td1 {
  text-align: left;
  padding-left: 30px;
  width: 18%;
  p:first-child {
    height: 22px;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    line-height: 22px;
    margin-bottom: 4px;
  }
  p:last-child {
    height: 17px;
    font-size: 12px;
    color: rgba(123, 123, 124, 1);
    line-height: 17px;
  }
}
.td2 {
  height: 29px;
  width: 14%;
  font-size: 24px;
  font-family: DIN-Medium;
  color: rgba(255, 97, 6, 1);
  line-height: 29px;
}
.td3 {
  height: 22px;
  width: 14%;
  font-size: 16px;
  color: #333;
  line-height: 22px;
}
.td4 {
  width: 28%;
  p:first-child {
    height: 17px;
    font-size: 12px;
    color: rgba(51, 51, 51, 1);
    line-height: 17px;
  }
}
.td5 {
  width: 25%;
  a {
    display: inline-block;
    width: 120px;
    height: 36px;
    line-height: 36px;
    color: #fff;
    background: linear-gradient(
      90deg,
      rgba(249, 195, 72, 1) 0%,
      rgba(255, 129, 58, 1) 100%
    );
    border-radius: 20px;
    &.finished{
      background:linear-gradient(90deg,rgba(129,169,250,1) 0%,rgba(74,112,242,1) 100%);
    }
  }
}
</style>
